import { render } from "./Icon.vue?vue&type=template&id=3053155c&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3053155c"

export default script